export default function directiveFocus(app) {
  // 注册一个全局自定义指令 `v-focus`
  app.directive('focus', {
    // 当被绑定的元素插入到 DOM 中时……
    inserted: function (el) {
      // 聚焦元素
      // el.focus()
      el.querySelector('input').focus()
    }
  })
}



// WEBPACK FOOTER //
// ./src/directive/focus.js